"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Step = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../../utils/classify"));
var _Icon = require("../../Icon");
var _StepperModule = _interopRequireDefault(require("../Stepper.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Step = exports.Step = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    active,
    children,
    completed = false,
    disabled = false,
    expanded = false,
    index = 0,
    last,
    classNames,
    onClick,
    allowClick,
    iconName,
    iconType
  } = _ref;
  const childrenArray = React.Children.toArray(children).filter(Boolean);
  const stepContent = childrenArray.map(stepContent =>
  /*#__PURE__*/
  // @ts-ignore - TS2769 - No overload matches this call.
  React.cloneElement(stepContent, {
    // @ts-ignore - TS2339 - Property 'props' does not exist on type 'string | number | bigint | ReactElement<unknown, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | Promise<...>'.
    ...stepContent.props,
    active,
    completed,
    disabled
  }));
  const handleClick = e => allowClick && onClick?.(index, e);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: (0, _classify.default)(_StepperModule.default.stepWrapper, {
      [_StepperModule.default.active]: active,
      [_StepperModule.default.completed]: completed,
      [_StepperModule.default.expanded]: expanded,
      [_StepperModule.default.last]: last,
      [_StepperModule.default.disabled]: disabled,
      [_StepperModule.default.clickable]: allowClick
    }, classNames?.wrapper),
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_StepperModule.default.stepWrapperCounter, {
      [_StepperModule.default.selected]: active,
      [_StepperModule.default.completed]: completed,
      [_StepperModule.default.expanded]: expanded,
      [_StepperModule.default.last]: last,
      [_StepperModule.default.disabled]: disabled,
      [_StepperModule.default.withIcon]: !!iconName
    }, classNames?.stepCounter)
  }, completed && !active ?
  /*#__PURE__*/
  // @ts-ignore - TS2769 - No overload matches this call.
  React.createElement(_Icon.Icon, {
    name: "check",
    type: _Icon.ICON_TYPE.solid,
    size: _Icon.ICON_SIZE.small,
    className: _StepperModule.default.stepIcon
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, iconName ? /*#__PURE__*/React.createElement(_Icon.Icon, {
    name: iconName,
    className: _StepperModule.default.stepIcon
    // @ts-ignore - TS2769 - No overload matches this call.
    ,
    size: _Icon.ICON_SIZE.small,
    type: iconType
  }) : (index + 1).toString())), /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_StepperModule.default.stepContent, classNames?.content)
  }, stepContent));
});